<mg-report-table
  matSort
  [dataSourceService]="ds"
  [selectable]="canMultiSelect$ | async"
  [actionService]="actionService"
  [selectionMessage]="actionService.getSelectionMessage()"
  (matSortChange)="ds.sort($event)">
  <mg-role-column [datasource]="ds"></mg-role-column>
  <mg-archive-column [datasource]="ds"></mg-archive-column>
  <mg-edit-column [datasource]="ds"></mg-edit-column>
  <ng-template #actionBar>
    <mg-btn
      *ngIf="actionService.isSelectionValid()"
      variant="text"
      icon="mg-archive"
      iconSet="minga"
      (click)="actionService.archiveCheckin()">
      {{ MESSAGES.ARCHIVE_LABEL }}
    </mg-btn>
  </ng-template>
</mg-report-table>
